import {useMutation, useQueryClient} from '@tanstack/react-query'

import {logger} from '#/logger'
import {useChatClient, useSession} from '#/state/session'
import {chat} from '#/lexicons'
import {
  type ConvoRequestListQueryData,
  optimisticDeleteJoinRequest,
  RQKEY_ROOT as REQUESTS_RQKEY_ROOT,
} from './list-conversation-requests'

export function useWithdrawJoinGroupChatRequest({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: chat.bsky.group.withdrawJoinRequest.$OutputBody) => void
  onError?: (error: Error) => void
} = {}) {
  const client = useChatClient()
  const queryClient = useQueryClient()
  const {hasSession} = useSession()

  return useMutation({
    mutationFn: async ({convoId}: {convoId: string}) => {
      if (!hasSession)
        throw new Error('Must be logged in to withdraw a join request')
      if (!convoId) throw new Error('No convoId provided')

      return await client.call(chat.bsky.group.withdrawJoinRequest, {convoId})
    },
    onSuccess: (data, {convoId}) => {
      queryClient.setQueriesData<ConvoRequestListQueryData>(
        {queryKey: [REQUESTS_RQKEY_ROOT]},
        old => optimisticDeleteJoinRequest(convoId, old),
      )
      onSuccess?.(data)
    },
    onError: error => {
      logger.error('Failed to withdraw join request', {safeMessage: error})
      onError?.(error)
    },
  })
}
